import type { UserPreferences } from '@ms-cloudpack/common-types';
import type { CommandAction } from '../../types/CommandAction.js';
import { updateUserPreference } from '@ms-cloudpack/config';

export interface DeleteArguments {
  key: string;
}

/** Delete a Cloudpack user preference value. */
export const execute: CommandAction<never> = async (params) => {
  const { args } = params;
  const key = args[0] as keyof UserPreferences;

  try {
    // Commander should have validated the key based on the given choices, and the update
    // function will also validate its input.
    await updateUserPreference({ key, deleteValue: true });
    // Following the pattern of other tools, we don't output anything on success,
    // or if the key was valid but didn't exist.
    return { message: '' };
  } catch (err) {
    return {
      hasErrors: true,
      message: `Failed to delete "${key}": ${(err as Error).message || err}`,
    };
  }
};
